import { Injectable } from '@angular/core';
import { CusHttp } from '../../core/services/CusHttp';
import { URLSearchParams } from "@angular/http";

// 检查检查学生是否投递过这个岗位
const GETTHINKDATA_URL = "v1/resume/getSearch";


@Injectable()
export class InputOptionService {

  constructor(public _http: CusHttp, ) { }
  getThinkData(type: any, name: any) {
    let url = GETTHINKDATA_URL + `?type=${type}&name=${name}`;
    return this._http.get(url);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/input-option/input-option.service.ts